import { Directive } from 'angular-ts-decorators';

/**
 * ngClick replacement that accepts only actions that returns a **promise**. The element will be
 * disabled until promise is resolved/rejected. Additionaly button action status is available as
 * a class:
 * * sw-pending - action was already requested, but not resolved/reject jet
 * * sw-resolved - actions was resolved
 * * sw-rejected - actions was rejected
 *
 * ## Usage example
 * <pre>
 *   <button sw-click="action()"></button>
 * </pre>
 */
@Directive({
  selector: '[sw-click]',
})
export class SwClickDirective {
  constructor(
    private $element: ng.IAugmentedJQuery,
    private $scope: ng.IScope,
    private $attrs: ng.IAttributes,
    private $parse: ng.IParseService,
    private sentry,
  ) {
    'ngInject';
  }

  $postLink() {
    const swClick = this.$parse(this.$attrs.swClick);

    this.$element.on('click', () => {
      this.$scope.$apply(() => {
        const clickPromise = swClick(this.$scope);

        this.$attrs.$set('disabled', true);
        this.$element.addClass('sw-pending');
        this.$element.removeClass('sw-resolved');
        this.$element.removeClass('sw-rejected');

        if (clickPromise && angular.isFunction(clickPromise.then)) {
          clickPromise.then(
            () => {
              this.$attrs.$set('disabled', false);
              this.$element.removeClass('sw-pending');
              this.$element.addClass('sw-resolved');
            },
            () => {
              this.$attrs.$set('disabled', false);
              this.$element.removeClass('sw-pending');
              this.$element.addClass('sw-rejected');
            },
          );
        } else {
          this.sentry.captureException(
            new Error('sw-click action did not returned promise, exiting'),
            {
              extra: {
                swClick: swClick.toString(),
                element: this.$element[0].outerHTML,
              },
            },
          );
        }
      });
    });
  }
}
